import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'comboSearch',
    standalone: false
})
export class ComboSearchPipe implements PipeTransform {
  transform(items: any[], searchText: string, labelKey: string = 'label'): any[] {
    if (!items) return [];
    if (!searchText) return items;
    const lowerSearch = searchText.toLowerCase();
    return items.filter(item =>
      item[labelKey] && item[labelKey].toString().toLowerCase().includes(lowerSearch)
    );
  }
}